import {
  ALLLINKS,
  ALLLINKSBYUSER,
  ALLREVIEWS,
  THANKYOU,
  BADFEEDBACK,
  ALLLINKSBYADMIN,
  MODAL,
  VIEW_BY_ID,
  VIEWNAVITEMBYID,
  VIEWTITLE,
  LOGEDIN_DEVICE
} from "../../utils/actionTypes";

const initial_state = {
  all_linkslength: 0,
  all_links: [],
  viewLinksByUser: {},
  all_reviews: [],
  all_reviewslength: 0,
  thankyou: false,
  badfeedback: [],
  badfeedback_length: 0,
  allLinksByAdmin: {},
  view_by_id: {},
  modal: false,
  viewnavitembyid: {},
  viewtitle: {},
  logedin_device: {},
};
export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case ALLLINKS:
      return (state = {
        ...state,
        all_links: action.payload,
        all_linkslength: action.count,
      });
    case ALLLINKSBYUSER:
      return (state = {
        ...state,
        viewLinksByUser: action.payload,
      });
    case THANKYOU:
      return (state = {
        ...state,
        thankyou: action.payload,
      });

    case BADFEEDBACK:
      return (state = {
        ...state,
        badfeedback: action.payload,
        badfeedback_length: action.count,
      });
    case ALLREVIEWS:
      return (state = {
        ...state,
        all_reviews: action.payload,
        all_reviewslength: action.count,
      });
    case ALLLINKSBYADMIN:
      return (state = {
        ...state,
        allLinksByAdmin: action.payload,
      });

    case VIEW_BY_ID:
      return (state = {
        ...state,
        view_by_id: action.payload,
      });
    case MODAL:
      return (state = {
        ...state,
        modal: action.payload,
      });
    case VIEWNAVITEMBYID:
      return (state = {
        ...state,
        viewnavitembyid: action.payload,
      });
    case VIEWTITLE:
      return (state = {
        ...state,
        viewtitle: action.payload,
      });
    case LOGEDIN_DEVICE:
      return (state = {
        ...state,
        logedin_device: action.payload,
      });
    default:
      return state;
  }
}
